module.exports = __webpack_public_path__ + "media/images/footer-logo-66fdea8e665323062c1acb0ff0c4ed6b.svg";